/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Status_ReadInputs */

const cs_chat_status_read = /** @type {(inputs: Chat_Status_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přečteno`)
};

const en_chat_status_read = /** @type {(inputs: Chat_Status_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read`)
};

/**
* | output |
* | --- |
* | "Read" |
*
* @param {Chat_Status_ReadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_status_read = /** @type {((inputs?: Chat_Status_ReadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Status_ReadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_status_read(inputs)
	return cs_chat_status_read(inputs)
});